/* import __COLOCATED_TEMPLATE__ from './price-view-tab-controller.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();